(function (angular) {
    'use strict';

    angular.module('channels')

        /**
         *
         */
        .factory('messengerChannelService',
        ['$uibModal','$rootScope', 'facebookService', '$stateParams',
                function ($uibModal, $rootScope, facebookService, $stateParams) {


                    var fac = {
                        getMessengerConfig: getMessengerConfig,
                        deleteFacebookChannel: deleteFacebookChannel
                    };

                    return fac;

                    function getMessengerConfig(config) {
                        return $uibModal.open({
                            templateUrl: 'components/channels/messenger/templates/messenger.html',
                            size: 'lg',
                            backdrop: 'static',
                            resolve: {
                                config: function () {
                                    return config || false;
                                },
                                fbData: ['$q', 'facebookService', '$stateParams', function ($q, facebookService, $stateParams) {
                                    return facebookService.getPageFromComapi($stateParams.pickedApiSpaceId)
                                        .then(function (response) {
                                            return response;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(false); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });

                                }]
                            },
                            controller: 'messengerController'
                        });

                    }
                    function deleteFacebookChannel() {
                        return facebookService.deleteFacebookConfig($stateParams.pickedApiSpaceId)
                            .then(function () {
                                growlService.success('Facebook successfully deleted');
                                $rootScope.$broadcast('FB channel deleted');

                            }).catch(function (error) {
                                growlService.danger("Facebook wasn't successfully deleted due to: " + error.statusText);
                            });
                    }


                }]);

})(window.angular);